var LocationVariant;
(function(LocationVariant) {
    LocationVariant["ListItem"] = "ListItem";
    LocationVariant["StandAlone"] = "StandAlone";
    LocationVariant["MapItem"] = "MapItem";
})(LocationVariant || (LocationVariant = {}));

export { LocationVariant };
//# sourceMappingURL=types.js.map
